import React from 'react'
import Navbar from '../../components/navbar_poc'
import { Link } from 'react-router-dom'
import bg1 from '../../assets/images/cover2.jpg'
import client from '../../assets/images/client/05.jpg'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'
import SEO from '../../components/seo'
import PodcastPlayer from '../../components/podcast-player'
import { about, footerLinks, footerBlogSocial, landing, location, serviceStages } from '../../data'
export default function PagePodcastPreview() {
  return (
    <>
    <Navbar navLight={true}/> 
    <SEO
  title="AI Labs at Pioneer One Global – Automate, Optimize, and Scale"
  description="From intelligent compliance to AI-driven operations, Pioneer One Global’s AI Labs help you harness automation for smarter growth in India and beyond."
  url="https://www.pioneeroneglobal.com/ai-labs"
  image="https://www.pioneeroneglobal.com/images/og-ai-labs.jpg"
/>
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row position-relative align-items-center pt-4">
              <div className="col-lg-6">
                  <div className="title-heading p-4 rounded bg-white shadow mt-4">
                      <span className="badge bg-primary rounded-pill">Podcast</span>
                      <h2 className="mt-3">Roots and Wings</h2>
                      <p className="para-desc text-muted">A podcast about growth - of people, companies and countries.</p>
                      <div className="mt-4">
                          <div className="d-flex">
                              {/* <img src={client} className="img-fluid avatar avatar-small rounded-pill me-3 shadow" alt=""/> */}
                              <div className="author mt-3">
                                  <h5 className="mb-0"><Link to="#" className="text-dark name">Siva Bala Narayanan</Link></h5>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="casestudy">
                       <p className="text-muted description">Roots and Wings is a podcast recorded by Siva Bala Narayanan — founder of Pioneer One Global, marathon runner, Gita student, and father of three.</p>

                      <p className="text-muted description">It explores what it takes to grow — as a person, as a company, and as a nation.</p>
                      <p className="text-muted description">Through personal stories, deep ideas, and reflections on India@2047, this podcast invites listeners to rethink their role in shaping the future.</p>
                      
                                            <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                                <ul className="list-unstyled text-sm-end social-icon social mb-0">
                                                    {footerBlogSocial.map((item,index)=>{
                                                        let Icon = item.icon
                                                        return(
                                                            <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><i className=" align-middle"><Icon/></i></Link></li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                      
                      <h4 className="mt-4">Latest Episode</h4>
                      <div>
                      <PodcastPlayer/>
                      </div>
                     
                      <p className="text-muted description">In this opening episode of Roots and Wings, Siva Bala Narayanan explores what it truly means to grow — as a person, as a company, and as a country. Blending personal insight with philosophical depth, the episode introduces key themes like mindset change, swadharma, and India@2047. It’s a call to action for global Indians, well-wishers of India, and anyone who believes their story can shape the future.</p>
                        </div>
                      
                      
              </div>
             </div>
             <div className="row">
             <div className="col-12">
             <h4 className="mt-4">About the Author</h4>
             <p className="text-muted description">Siva Bala Narayanan is the founder of Pioneer One Global. Having spent half his life in India and the other half in the U.S., he helps global companies navigate the complexity and promise of India. A marathon runner, former chess coach, and lifelong student of the Bhagavad Gita, Siva believes that real growth — whether in business, personal life, or nation-building — begins with mindset, discipline, and inner clarity. As a parent of three daughters raised with both roots and wings, he now extends that philosophy through this podcast: an invitation to reflect, take responsibility, and shape India’s future story.</p>

              
                </div>
                </div>
      </div>
          <div className="container mt-100 mt-60">
                <div className="bg-white rounded p-md-5 p-4 p-sm-0 shadow">
                    <div className="row align-items-center">
                        <div className="col-sm-7">
                            <div className="text-sm-start">
                                <h4>Helping You Grow with India</h4>
                                <p className="text-muted description">This podcast is brought to you by Pioneer One Global — helping global companies explore, enter, and grow in India.</p>
                                <p className="text-muted description">If you're a founder, operator, or executive thinking about India, we’d love to talk.</p>
                         
                             </div>
                        </div>
      
                        <div className="col-sm-5 mt-4 mt-sm-0">
                            <div className="text-sm-end">
                                <Link to="/contact" className="btn btn-outline-primary"><i className="mdi mdi-phone-outline"></i> Get in touch!</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
